// extracted by mini-css-extract-plugin
module.exports = {"button":"AddLayoutGroup_button__2MPV9","title":"AddLayoutGroup_title__12lTr","formWrapper":"AddLayoutGroup_formWrapper__3LJ18"};